import RefreshIcon from '@mui/icons-material/Refresh';
import { IconButton } from '@mui/material';
import axios from 'axios';
import { noop } from 'lodash';
import { enqueueSnackbar } from 'notistack';
import { useCallback, useEffect, useState } from 'react';

import packageJson from '../../../package.json';

const AppVersion = () => {
  const [isLatestVersion, setIsLatestVersion] = useState(true);
  const currentVersion = packageJson.version;

  const fetchVersion = useCallback(() => {
    axios
      .get(`/appConfig.json?time=${Date.now()}`)
      .then((payload) => {
        setIsLatestVersion(payload.data.currentVersion === currentVersion);
      })
      .catch(noop);
  }, [currentVersion]);

  useEffect(() => {
    fetchVersion();
    const interval = setInterval(fetchVersion, 600_000); // 10 minutes

    return () => clearInterval(interval);
  }, [fetchVersion]);

  useEffect(() => {
    if (!isLatestVersion) {
      enqueueSnackbar('Application out of date, refresh app.', {
        preventDuplicate: true,
        variant: 'info',
        persist: true,
        autoHideDuration: null,
        action: () => (
          <IconButton color='inherit' onClick={() => window.location.reload()} aria-label='Refresh'>
            <RefreshIcon />
          </IconButton>
        ),
      });
    }
  }, [isLatestVersion]);

  return null;
};

export default AppVersion;
